import * as React from 'react';
import { RouteComponentProps } from "react-router";
import { PluginTemplates } from "../utils/PluginTemplates";
import FalconFooter from "../components/navigation/FalconFooter";
import FalconHeader from "../components/navigation/FalconHeader";
import {FalconNavigatorHeader, CAR_PIU_PDF_NAME, CAR_PIU_PDF_PATH} from "@falcon/services";

interface IProps extends RouteComponentProps<{}> {
}

export class PersonalDataRightsPage extends React.Component<IProps> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Personal data rights");
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="plugin personal-data-rights-page">
                    <FalconNavigatorHeader title="Personal data rights"/>
                    <div className="panel">
                        <div className="static-page-wrapper">
                            <h5>Your personal information rights</h5>
                            <p>You have a right in certain circumstances to:</p>
                            <ul>
                                <li>access the personal information we hold about you</li>
                                <li>current personal information</li>
                                <li>have your personal information deleted</li>
                                <li>restrict us processing your personal information</li>
                                <li>receive your personal information in a portable format, and</li>
                                <li>object to us processing your personal information</li>
                            </ul>
                        </div>
                        <div className="static-page-wrapper">
                            <p>You can also ask for a person to review an automated decision. If you want to find out more or to exercise these rights please email us at{' '}
                                <a className="no-underline" href="mailto:customerrelations_flow@lv.co.uk" target="_blank"
                                   id="glCustomerSupport">customerrelations_flow@lv.co.uk</a>
                            </p>
                        </div>
                        <div className="static-page-wrapper">
                            <p>
                                We'll only send you marketing information about our Allianz products and services
                                if you've given us permission. You can withdraw your consent at any time.
                            </p>
                        </div>
                        <div className="static-page-wrapper">
                            <p>Allianz is underwritten by Liverpool Victoria Insurance Company Limited. Liverpool Victoria Insurance Company Limited is the controller of your
                                personal information. We'll keep you informed about how we use your personal information in the document{' '}
                                <a className="no-underline" href={CAR_PIU_PDF_PATH} target="_blank"
                                   id="glCustomerSupport"> '{CAR_PIU_PDF_NAME}'</a>.
                            </p>
                        </div>
                    </div>
                    <div className="aligned-left">
                        {this.pluginTemplates.renderBackButton()}
                    </div>
                </div>
                <FalconFooter/>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/PersonalDataRightsPage.tsx